import React from 'react';
import { useParams } from 'react-router-dom';

import { DmMessagesChip } from './combatpro/integration/PrivateCampaignMessages';
import InformationChip from './combatpro/integration/InformationWorkspace';
import GeneratorCatalogueChip from './combatpro/integration/GeneratorCatalogueWorkspace';
import GeneratorContextChip from './combatpro/integration/GeneratorContextWorkspace';
import { LayeredModalHost, LayeredModalProvider } from './combatpro/integration/ui/LayeredWorkspace';
import './combatpro/styles/combatProTheme.css';

export default function CombatProPlayerMessagesPage() {
  const { campaignId } = useParams();
  return <div className="cp-root cp-player-message-entry"><LayeredModalProvider>
    <main className="cp-player-message-entry-card">
      <div className="cp-layer-eyebrow">Combat PRO Campaign</div>
      <h1>Private campaign messages</h1>
      <p>Open the structured information, questions, decisions and private reveals sent to your linked player account.</p>
      <GeneratorContextChip mode="player" campaignId={campaignId} />
      <GeneratorCatalogueChip mode="player" context="players" campaignId={campaignId} />
      <InformationChip mode="player" campaignId={campaignId} />
      <DmMessagesChip campaignId={campaignId} />
    </main>
    <LayeredModalHost />
  </LayeredModalProvider></div>;
}
